import clsx from 'clsx';
import { ReactNode, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import { GlobalSearchTracking } from '../../constants/global-search-tracking';
import { useGlobalSearchContext } from '../../hooks/useGlobalSearchContext';
import { GlobalSearchItem } from '../../interfaces/global-search';
import styles from './GlobalSearchEntityListItem.module.scss';

interface GlobalSearchEntityListItemProps {
  children: ReactNode;
  entity: GlobalSearchItem;
  entityType: string;
}

export function GlobalSearchEntityListItem({
  children,
  entity,
  entityType
}: GlobalSearchEntityListItemProps) {
  const { closeDialog } = useGlobalSearchContext();
  const navigate = useNavigate();
  const { eventTrack } = useAnalyticsTracker();

  const listItemRef = useRef<HTMLDivElement>(null);

  const onClick = () => {
    eventTrack({
      action: GlobalSearchTracking.TRACKER_GLOBAL_SEARCH_RESULT_CLICK,
      properties: {
        entityType
      }
    });

    if (!entity.isExitURLExternal) {
      navigate(entity.exitURL, { replace: true });
      closeDialog();
    } else {
      window.open(entity.exitURL, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className={clsx(styles.listItem, 'keyboard-nav-item')}
      ref={listItemRef}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.currentTarget.click();
        }
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
